import script from "./SixDots.vue?vue&type=script&setup=true&lang=js"
export * from "./SixDots.vue?vue&type=script&setup=true&lang=js"

import "./SixDots.vue?vue&type=style&index=0&id=765bd8f4&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765bd8f4"]])

export default __exports__